module.exports = __webpack_public_path__ + "img/Argentina.507e394f.png";